import { Fragment, useRef } from 'react';
import { breakpoints, vars } from '@etg/wings';
import type { SubMenuItem } from '@eti/schema-types';
import { css } from '@eti/styles';
import { Question } from '@phosphor-icons/react';
import { useMediaQuery } from 'usehooks-ts';
import SiteButtonWithDropdownMenu from './SiteButtonWithDropdownMenu';

const buttonWrapperStyles = css`
  position: relative;
`;

const buttonStyles = css`
  &:focus-visible {
    outline-color: ${vars.colors.header.content};
  }

  @media print {
    display: none;
  }
`;

interface SupportMenuProps {
  menu: {
    menuType: string;
    name: string;
    path: string | null;
    subMenu: SubMenuItem[];
  }[];
}

const SupportMenu = ({ menu }: SupportMenuProps) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const isWiderViewport = useMediaQuery(`(min-width: ${breakpoints._970})`);

  return (
    <div data-testid="support-menu" ref={wrapperRef}>
      {menu.map(({ name, subMenu }, index) => (
        <Fragment key={`support-menu-${index}`}>
          {subMenu?.length > 0 && (
            <div className={buttonWrapperStyles}>
              <SiteButtonWithDropdownMenu
                className={buttonStyles}
                hideLabel={!isWiderViewport}
                iconPrefix={<Question aria-hidden />}
                label={name}
                menu={subMenu}
                menuId="support-menu"
                withBorder={false}
                wrapperRef={wrapperRef}
              />
            </div>
          )}
        </Fragment>
      ))}
    </div>
  );
};

export default SupportMenu;
